<template>
	<div class="monitor-container">
		<!-- 右侧事件全览面板 -->
		<div class="event-panel breath-panel">
			<div class="event-header">
				<div class="title">事件全览</div>
				<div class="header-actions">
					<div>事件/办位/等级/状态/导出</div>
				</div>
			</div>

			<!-- 顶部统计卡片 -->
			<div class="stats-row">
				<div class="stat-card">
					<div class="label">当前筛选</div>
					<div class="value">18台</div>
				</div>
				<div class="stat-card">
					<div class="label">可导出记录</div>
					<div class="value">18台</div>
				</div>
				<div class="stat-card">
					<div class="label">最近导出</div>
					<div class="value">99.7%</div>
				</div>
			</div>

			<!-- 状态标签栏 -->
			<div class="tab-bar">
				<div :class="{'tab-item':true,active:tabIndex == null}" @click="tabClick(null)">全部</div>
				<div :class="{'tab-item':true,active:tabIndex == 0}" @click="tabClick(0)" class="tab-item">紧急</div>
				<div :class="{'tab-item':true,active:tabIndex == 1}" @click="tabClick(1)" class="tab-item">重要</div>
				<div :class="{'tab-item':true,active:tabIndex == 2}" @click="tabClick(2)" class="tab-item">一般</div>
				<div :class="{'tab-item':true,active:tabIndex == 3}" @click="tabClick(3)" class="tab-item">关注</div>
			</div>

			<!-- 事件列表 -->
			<div class="event-list">
				<!-- @click="openPopup(index)" -->
				<!-- @click="get_warn_detail(item)" -->
				<div class="event-item" :class="{urgent:item.warnLevel == 0,warning:item.warnLevel == 1}"
					v-for="(item, index) in page_warn_listData" :key="index" >
					<!-- <div class="event-time">{{ item.warnTime }}</div> -->
					<div class="event-content">
						<div class="event-title">{{ item.warnName }}</div>
						<div class="event-subtitle">{{ item.warnContent }}</div>
					</div>
					<div class="event-status"
						:class="{'status-red':item.warnLevel == 0,'status-yellow':item.warnLevel == 1}"
						@click="openHandle(item)">
						<!-- {{ item.warnStatus }} -->
						操作
					</div>
				</div>
			</div>
		</div>

		<!-- 操作弹窗！！！！ -->
		<div class="event-popup" v-if="popupVisible">
			<div class="popup-header">
				<div class="popup-title">
					<div class="event-id">事件全览/{{get_warn_detailData.warnId}}</div>
					<div class="event-name">{{get_warn_detailData.warnName}}</div>
				</div>
				<img class="close-btn" @click="closePopup" src="@/assets/close.png" alt="" />
			</div>
			<div class="popup-content state2" v-if="get_warn_detailData.videoFile">
				<div class="video-area">
					<div class="video-title">泵房CAM-18B1泵房/视频增强</div>
					<div class="video-placeholder">
						<img src="https://picsum.photos/id/180/400/250" alt="视频画面" />
						<div class="live-tag">LIVE/25fps</div>
					</div>
					<div class="info-grid">
						<div class="info-item">
							<div class="label">供水压力P-01</div>
							<div class="value">0.68 MPa</div>
						</div>
						<div class="info-item">
							<div class="label">供水压力P-01</div>
							<div class="value">0.68 MPa</div>
						</div>
						<div class="info-item">
							<div class="label">供水压力P-01</div>
							<div class="value">0.68 MPa</div>
						</div>
						<div class="info-item">
							<div class="label">供水压力P-01</div>
							<div class="value">0.68 MPa</div>
						</div>
					</div>
					<div class="status-tips">
						<div class="tip">画面联动已打开</div>
						<div class="tip red">烟火识别/人员闯入</div>
					</div>
				</div>
				<div class="info-row">
					<div class="info-item">
						<div class="label">告警点位</div>
						<div class="value">B1泵房/CAM-08</div>
					</div>
					<div class="info-item">
						<div class="label">触发源</div>
						<div class="value">视频设备离线恢复</div>
					</div>
				</div>
				<div class="info-row">
					<div class="info-item">
						<div class="label">告警点位</div>
						<div class="value">B1泵房/CAM-08</div>
					</div>
					<div class="info-item">
						<div class="label">触发源</div>
						<div class="value">视频设备离线恢复</div>
					</div>
				</div>
				<div class="info-row">
					<div class="info-item">
						<div class="label">告警点位</div>
						<div class="value">B1泵房/CAM-08</div>
					</div>
					<div class="info-item">
						<div class="label">触发源</div>
						<div class="value">视频设备离线恢复</div>
					</div>
				</div>
			</div>
			<div class="popup-content state1" v-else>
				<div class="info-row">
					<div class="info-item">
						<div class="label">告警点位</div>
						<div class="value">{{get_warn_detailData.areaName}}/{{get_warn_detailData.equipType}}</div>
					</div>
					<div class="info-item">
						<div class="label">触发源</div>
						<div class="value">{{get_warn_detailData.equipName}}</div>
					</div>
				</div>
				<div class="section-title">事件处置链路</div>
				<div class="process-list">
					<div class="process-item" v-for="(item,index) in get_warn_detailData.warnRecordList" :key="index">
						<div class="time">{{item.updateTime}}</div>
						<div class="text">核心机房接口波动</div>
						<div class="status">{{item.warnStatus}}</div>
					</div>
				</div>

				<div class="section-title">事件处置链路</div>
				<div class="info-row">
					<div class="info-item">
						<div class="label">告警点位</div>
						<div class="value">B1泵房/CAM-08</div>
					</div>
					<div class="info-item">
						<div class="label">触发源</div>
						<div class="value">视频设备离线恢复</div>
					</div>
				</div>
				<div class="info-row">
					<div class="info-item">
						<div class="label">告警点位</div>
						<div class="value">B1泵房/CAM-08</div>
					</div>
					<div class="info-item">
						<div class="label">触发源</div>
						<div class="value">视频设备离线恢复</div>
					</div>
				</div>

				<div class="section-title">事件操作</div>
				<div class="action-divs">
					<div class="action-btn">开始处置</div>
					<div class="action-btn">查看视频</div>
				</div>
				<div class="action-divs">
					<div class="action-btn">通知值守</div>
					<div class="action-btn">处置结果</div>
				</div>
			</div>
		</div>

		<!-- 警报处理弹窗（Element UI el-dialog） -->
		<el-dialog :visible.sync="handlePopupVisible" width="2.7rem" :close-on-click-modal="false" append-to-body custom-class="handle-dialog">
			<div class="dialog-title">警报处理</div>
			<el-form label-width="80px" size="small">
				<el-form-item label="处理动作" required>
					<el-select v-model="handleForm.action" placeholder="请选择" style="width:100%">
						<el-option label="已忽略" value="1"></el-option>
						<el-option label="标记已恢复" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注信息">
					<el-input  type="textarea" v-model="handleForm.remark" placeholder="请输入备注" :rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div class="dialog-btns">
				<el-button size="small" @click="closeHandlePopup">取消</el-button>
				<el-button size="small" type="primary" @click="confirmHandle">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import wsService from '@/utils/websocketService'
	
	export default {
		name: 'MonitorPage',
		data() {
			return {
				tabIndex: null,
				popupVisible: false,
				popupState: 1, // 1:无视频无数据 2:有视频无数据 3:有视频有数据
				page_warn_listData: [],
				pageNumber: 1,
				pageSize: 100,
				get_warn_detailData: {},
				handlePopupVisible: false, // 警报处理弹窗
				currentWarnId: null, // 当前处理的事件 warnId
				handleForm: {
					action: '', // 处理动作：1已忽略 2标记已恢复
					remark: ''
				}
			}
		},
		created() {
			this.page_warn_list()
		},
		mounted() {
			// 初始化告警 WebSocket
			wsService.initWarnWs(this.handleWarnMessage)
		},
		beforeDestroy() {
			// 组件销毁时取消订阅
			wsService.unsubscribeWarn(this.handleWarnMessage)
		},
		methods: {
			// 处理告警 WebSocket 消息
			handleWarnMessage(message) {
				console.log('[eventAlertRight] 收到告警推送:', message)
				// 刷新告警列表
				this.page_warn_list()
			},
			page_warn_list() {
				this.$http.get(this.$api.BASE_URL_Category.page_warn_list, {
					pageNumber: this.pageNumber,
					pageSize: this.pageSize,
					warnLevel: this.tabIndex
				}).then(res => {
					this.page_warn_listData = res.data.data;
				}).catch(err => {
					console.error('获取告警列表失败：', err)
				})
			},
			get_warn_detail(item) {
				this.$http.get(this.$api.BASE_URL_Category.get_warn_detail, {
					warnId: item.warnId,
				}).then(res => {
					this.get_warn_detailData = res.data;
				})
			},
			// 点击"操作"打开警报处理弹窗
			openHandle(item) {
				this.currentWarnId = item.warnId;
				this.handleForm.action = '';
				this.handleForm.remark = '';
				this.handlePopupVisible = true;
			},
			closeHandlePopup() {
				this.handlePopupVisible = false;
			},
			// 确认处理：校验必填 → 调 dealWarn
			confirmHandle() {
				if (!this.handleForm.action) {
					this.$message.warning('请选择处理动作');
					return;
				}
				if (!this.currentWarnId) return;
				this.dealWarn(this.handleForm.action);
			},
			// 事件处理：warnDealAction 1忽略 2恢复，调 /warn/deal-warn
			dealWarn(action) {
				this.$http.post(this.$api.BASE_URL_Category.deal_warn, {
					warnId: this.currentWarnId,
					warnDealAction: action,
					remark: this.handleForm.remark || undefined
				}).then(res => {
					if (res && res.code === 200) {
						this.$message.success(res.msg || '处理成功');
						this.handlePopupVisible = false;
						this.page_warn_list();
					} else {
						this.$message.error((res && res.msg) || '处理失败，请重试');
					}
				}).catch(err => {
					console.error('[dealWarn] 处理失败:', err);
					this.$message.error('处理失败，请重试');
				})
			},
			tabClick(index) {
				this.tabIndex = index;
				this.page_warn_list()
			},
			openPopup(index) {
				if (index === 0) {
					this.popupState = 1
				} else if (index === 1) {
					this.popupState = 2
				}
				this.popupVisible = true
			},
			closePopup() {
				this.popupVisible = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.monitor-container {
		width: 420px;
		height: 979px;
		position: absolute;
		top: 90px;
		right: 10px;
		z-index: 2;

		.event-panel {
			width: 100%;
			height: 100%;
			background: rgba(10, 22, 40, 0.85);
							// border: 1px solid rgba(0, 150, 255, 0.3);
			border-radius: 8px;
			padding: 12px 10px;
			box-sizing: border-box;
			color: #B3C8DC;

			.event-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 15px;

				.title {
					font-size: 16px;
				}

				.header-actions {
					font-size: 12px;
					color: #B3C8DC;
				}
			}

			.stats-row {
				display: flex;
				justify-content: space-between;
				margin-bottom: 16px;

				.stat-card {
					width: 122px;
					height: 62px;
					padding: 9px;
					text-align: center;
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					border-radius: 7px;
								// 		// border: 1px solid #4578A8;

					.label {
						font-size: 10px;
						color: #B3C8DCFFF;
						margin-bottom: 10px;
					}

					.value {
						font-weight: 800;
						font-size: 16px;
						color: #B3C8DCFFF;
					}
				}
			}

			.tab-bar {
				display: flex;
				align-items: center;
				margin-bottom: 15px;
				justify-content: space-between;

				.tab-item {
					cursor: pointer;
					width: 60px;
					height: 30px;
					line-height: 28px;
					text-align: center;
					background: #172434;
					border-radius: 6px;
					border: 1px solid #2C3D52;
					font-size: 14px;
					color: #B3C8DC;

					&.active {
						color: #B3C8DC;
						background: #349DFF;
						border-color: #7ABFFF;
					}
				}
			}

			.event-list {
				height: calc(100% - 180px);
				overflow-y: auto;

				.event-item {
					display: flex;
					align-items: center;
					height: 48px;
					padding: 6px 10px;
					background: linear-gradient(180deg, rgba(122, 191, 255, 0.1) 0%, rgba(122, 191, 255, 0) 100%);
					border-radius: 8px;
					border: 1px solid #7ABFFF;
					margin-bottom: 12px;


					&.urgent {
						background: linear-gradient(0deg, rgba(255, 74, 74, 0.5) 0%, rgba(255, 86, 74, 0) 100%);
						border: 1px solid rgba(255, 74, 74, 0.5);
					}

					&.warning {
						background: linear-gradient(0deg, rgba(255, 190, 74, 0.5) 0%, rgba(255, 190, 74, 0) 100%);
						border: 1px solid rgba(255, 190, 74, 0.5);
					}


					.event-time {
						font-size: 10px;
						color: #B3C8DCFFF;
						margin-right: 20px;
					}

					.event-content {
						flex: 1;

						.event-title {
							font-weight: bold;
							font-size: 12px;
							color: #B3C8DCFFF;
							margin-bottom: 10px;
						}

						.event-subtitle {
							font-size: 10px;
							color: #B3C8DC;
						}
					}

					.event-status {
						cursor: pointer;
						width: 50px;
						height: 20px;
						line-height: 17px;
						text-align: center;
						background: #0E161E;
						border-radius: 4px;
						border: 1px solid #7ABFFF;
						font-size: 10px;
						color: #B3C8DCFFF;

						&.status-red {
							border: 1px solid rgba(255, 74, 74, 0.5);
						}

						&.status-yellow {
							border: 1px solid rgba(255, 190, 74, 0.5);
						}

					}
				}
			}
		}

		.event-popup {
			position: absolute;
			right: 420px;
			top: 165px;
			width: 420px;
			height: 638px;
			background: rgba(10, 22, 40, 0.95);
							// border: 1px solid rgba(0, 150, 255, 0.3);
			border-radius: 8px;
			padding: 16px;
			box-sizing: border-box;
			color: #B3C8DC;

			.popup-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 16px;

				.popup-title {
					.event-id {
						font-size: 12px;
						color: #7ABFFF;
						margin-bottom: 6px;
					}

					.event-name {
						font-size: 16px;
						color: #B3C8DCFFF;
					}
				}

				.close-btn {
					width: 24px;
					height: 24px;
					cursor: pointer;
					flex-shrink: 0;
				}
			}

			.popup-content {
				&.state1 {
					.info-row {
						display: flex;
						justify-content: space-between;
						margin-bottom: 12px;

						.info-item {
							width: 187px;
							height: 45px;
							background: rgba(9, 23, 36, 0.9);
							border-radius: 6px;
							padding: 5px 10px;
										// 		// border: 1px solid #4578A8;

							.label {
								font-size: 10px;
								color: #B3C8DC;
								margin-bottom: 6px;
							}

							.value {
								font-size: 12px;
								color: #B3C8DCFFF;
							}
						}
					}

					.section-title {
						font-size: 14px;
						color: #B3C8DCFFF;
						margin: 14px 0;
					}

					.process-list {
						.process-item {
							display: flex;
							justify-content: space-between;
							align-items: center;
							width: 385px;
							height: 38px;
							padding: 0 10px;
							background: linear-gradient(180deg, rgba(122, 191, 255, 0.1) 0%, rgba(122, 191, 255, 0) 100%);
							border-radius: 8px;
							border: 1px solid #7ABFFF;
							margin-bottom: 10px;

							.time {
								font-size: 10px;
								color: #B3C8DCFFF;
							}

							.text {
								flex: .8;
								font-size: 12px;
								color: #B3C8DCFFF;
							}

							.status {
								font-size: 12px;
								color: #5FE3FF;
							}
						}
					}

					.action-divs {
						display: flex;
						justify-content: space-between;
						margin-bottom: 12px;

						.action-btn {
							width: 187px;
							height: 35px;
							line-height: 33px;
							text-align: center;
							background: rgba(9, 23, 36, 0.9);
							border-radius: 6px;
										// 		// border: 1px solid #4578A8;
							cursor: pointer;
							font-size: 12px;
							color: #B3C8DCFFF;
						}
					}
				}

				&.state2 {
					.video-area {
						width: 384px;
						height: 383px;
						background: rgba(9, 23, 36, 0.9);
						border-radius: 8px;
						padding: 8px 10px;
									// 		// border: 1px solid #4578A8;
						margin-bottom: 11px;

						.video-title {
							font-size: 12px;
							color: #B3C8DC;
							margin-bottom: 8px;
						}

						.video-placeholder {
							position: relative;
							height: 200px;
							background: rgba(9, 23, 36, 0.9);
							border-radius: 8px;
							border: 1px solid #4E7FAC;
							margin-bottom: 10px;

							img {
								width: 100%;
								height: 100%;
							}

							.live-tag {
								position: absolute;
								top: 8px;
								right: 8px;
								font-size: 12px;
								color: #5FE3FF;
							}
						}
					}

					.info-grid {
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;
						margin-bottom: 16px;
						gap: 10px;

						.info-item {
							width: 175px;
							height: 45px;
							background: rgba(9, 23, 36, 0.9);
							border-radius: 6px;
							padding: 5px 10px;
										// 		// border: 1px solid #4578A8;

							.label {
								font-size: 10px;
								color: #B3C8DC;
								margin-bottom: 6px;
							}

							.value {
								font-size: 12px;
								color: #B3C8DCFFF;
							}
						}
					}

					.status-tips {
						display: flex;
						justify-content: space-between;
						margin-bottom: 16px;

						.tip {
							font-size: 12px;
							color: #B3C8DC;

							&.red {
								font-size: 12px;
								color: #7ABFFF;
							}
						}
					}

					.info-row {
						display: flex;
						justify-content: space-between;
						margin-bottom: 12px;

						.info-item {
							width: 187px;
							height: 45px;
							background: rgba(9, 23, 36, 0.9);
							border-radius: 6px;
							padding: 5px 10px;
										// 		// border: 1px solid #4578A8;

							.label {
								font-size: 10px;
								color: #B3C8DC;
								margin-bottom: 6px;
							}

							.value {
								font-size: 12px;
								color: #B3C8DCFFF;
							}
						}
					}
				}
			}
		}
	}
</style>

<style>
	/* 警报处理弹窗：深色科技风（与模型设备弹框配色一致）；append-to-body 后 scoped 不生效，用全局样式 + custom-class 定位 */
	.handle-dialog.el-dialog {
		background: linear-gradient(180deg, #0a1a2e 0%, #091724 100%);
		border: 1px solid #2C3D52;
		border-radius: 12px;
		box-shadow: 0 8px 40px rgba(0, 150, 255, 0.15);
		overflow: hidden;
	}

	.handle-dialog .el-dialog__header {
		padding: 0;
		background: linear-gradient(180deg, #0d2340 0%, #091724 100%);
		border-bottom: 1px solid #2C3D52;
	}

	.handle-dialog .el-dialog__headerbtn {
		top: 12px;
		right: 12px;
		z-index: 10;
	}

	.handle-dialog .el-dialog__headerbtn .el-dialog__close {
		color: #B3C8DC;
	}

	.handle-dialog .el-dialog__body {
		padding: 14px 20px 16px;
		color: #B3C8DC;
	}

	.handle-dialog .dialog-title {
		font-size: 16px;
		font-weight: bold;
		color: #B3C8DC;
		line-height: 24px;
		padding-right: 30px;
		padding-bottom: 10px;
		margin-bottom: 14px;
		border-bottom: 1px solid #1a2e44;
	}

	.handle-dialog .el-form-item {
		margin-bottom: 14px;
	}

	.handle-dialog .el-form-item:last-of-type {
		margin-bottom: 0;
	}

	.handle-dialog .el-form-item__label {
		color: #B3C8DC;
	}

	/* 下拉框 / 备注输入框：深色 */
	.handle-dialog .el-input__inner,
	.handle-dialog .el-textarea__inner {
		background: #172434;
		border: 1px solid #2C3D52;
		color: #B3C8DC;
	}

	.handle-dialog .el-input__inner::placeholder,
	.handle-dialog .el-textarea__inner::placeholder {
		color: #5a7a96;
	}

	.handle-dialog .el-input__inner:focus,
	.handle-dialog .el-textarea__inner:focus {
		border-color: #36d1ff;
	}

	/* 覆盖 App.vue 全局深色 textarea 样式，统一为模型弹框配色 */
	.handle-dialog .el-textarea__inner {
		background: #172434 !important;
		border: 1px solid #2C3D52 !important;
		color: #B3C8DC !important;
	}

	.handle-dialog .el-textarea__inner:focus {
		border-color: #36d1ff !important;
	}

	.handle-dialog .dialog-btns {
		text-align: right;
		padding-top: 14px;
	}

	.handle-dialog .el-button--default {
		background: #172434;
		border: 1px solid #2C3D52;
		color: #B3C8DC;
	}

	.handle-dialog .el-button--default:hover {
		color: #36d1ff;
		border-color: #36d1ff;
	}

	.handle-dialog .el-button--primary {
		background: #4A98F7;
		border-color: #4A98F7;
	}
</style>